import { render, staticRenderFns } from "./budget-sum-calc-gulevel-modal.vue?vue&type=template&id=bf4c47ca&"
import script from "./budget-sum-calc-gulevel-modal.vue?vue&type=script&lang=ts&"
export * from "./budget-sum-calc-gulevel-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports